import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from '../../../services/image-resize.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Banner } from '../../../../model/class/Banner';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-banner',
  templateUrl: './edit-banner.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-banner.component.css']
})
export class EditBannerComponent implements OnInit {

  newBanner: Banner;
  editando = false;

  loaders = {
    image: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  @Input()
  set banner(banner: Banner) {
    if (banner.id > 0) {
      this.editando = true;
    }

    this.newBanner = banner;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService
  ) {
  }

  ngOnInit() {
  }


  onSubmit() {
    this.activeModal.close(this.newBanner);
  }

  asigneImage(event: any) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        this.newBanner.nuevaImagen = file;
        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newBanner.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
        });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/edit-banner/edit-banner.component.ts